import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * Bookmark glyph based on Flaticon "performances" / favorite-list icon (id 3502689).
 * Uses currentColor so callers can set DesignSystem primary / textSecondary.
 */
const BOOKMARK_PATH =
  'M7.75 2.25h8.5c1.38 0 2.5 1.12 2.5 2.5v16.05c0 .86-.97 1.32-1.58.75L12 17.92 5.83 21.55c-.61.57-1.58.11-1.58-.75V4.75c0-1.38 1.12-2.5 2.5-2.5z';

export function SaveBookmarkIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d={BOOKMARK_PATH} />
    </SvgIcon>
  );
}

export function SaveBookmarkOutlineIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d={BOOKMARK_PATH}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default SaveBookmarkIcon;
